import QuestionnaireInspector from './QuestionnaireInspector';

export default QuestionnaireInspector;